// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nagw","content":"styles_content__2KBG1","row":"styles_row__2wUyi","footer":"styles_footer__35USV","phraseLength":"styles_phraseLength__HMzHQ"};